import { TBackgroundColor, TPadding } from "tw-generated";
import { TTailwindString, tw } from "utils/tw";

interface Props {
  header?: React.JSX.Element;
  footer?: React.JSX.Element;
  className?: TTailwindString;
  bgColor?: TBackgroundColor;
  isFlat?: boolean;
  contentPadding?: TPadding;
}

export default ({
  header,
  footer,
  className,
  bgColor,
  isFlat = false,
  contentPadding,
  children,
}: React.PropsWithChildren<Props>): React.JSX.Element => {
  const hasHeaderOrFooter = Boolean(header || footer);
  const outerStyles = tw(
    className,
    bgColor ?? "bg-white",
    isFlat ? null : "shadow-md",
    "rounded-lg",
    "h-full",
    "flex",
    "flex-col"
  );

  const innerStyles = tw("flex-1", "flex", "flex-col", "space-y-6", {
    [contentPadding ?? ""]: Boolean(contentPadding),
    "py-8": !contentPadding && !hasHeaderOrFooter,
    "py-4": !contentPadding && hasHeaderOrFooter,
  });

  return (
    <div className={outerStyles}>
      {header}

      <div className={innerStyles}>{children}</div>

      <span className={tw("flex-1")} />

      {footer}
    </div>
  );
};
